<template>
  <j-modal
    :title="title"
    :width="1000"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :maskClosable="false"
    :body-style="{ height: '580px', overflow: 'hidden', overflowY: 'scroll' }"
    @cancel="handleCancel"
    :okText="$t('确定')"
    :cancelText="$t('关闭')"
    :okButtonProps="{ class: { 'jee-hidden': disableSubmit } }"
  >
    <a-spin :spinning="confirmLoading">
      <j-form-container>
        <a-divider class="aDividerBlue" orientation="left">{{ $t('工单信息') }}</a-divider>
        <detail-list :col="3">
          <detail-list-item :term="$t('工单编号')">{{ model.ticketsNum }}</detail-list-item>
          <detail-list-item :term="$t('工单类型')">{{ model.ticketsType == 0 ? $t('换表') : '' }}</detail-list-item>
          <detail-list-item :term="$t('工单联系人')">{{ model.ticketsContact }}</detail-list-item>
        </detail-list>

        <detail-list :col="3">
          <detail-list-item :term="$t('紧急程度')">
            <a-tag :color="getTagColor(model.ticketsEmergency)">
              {{ setJJ(model.ticketsEmergency) }}
            </a-tag>
          </detail-list-item>
          <detail-list-item :term="$t('预约时间')">{{ model.ticketsDeadline }}</detail-list-item>
          <!-- <detail-list-item term="地理信息">{{model.ticketsLocation}}</detail-list-item> -->

          <detail-list-item :term="$t('联系电话')">{{ model.ticketsContactPhone }}</detail-list-item>
        </detail-list>
        <detail-list :col="3">
          <detail-list-item :term="$t('换表原因')" :itemCol="1">
            {{ changingMeterReason }}
          </detail-list-item>
          <detail-list-item :term="$t('备注信息')" :itemCol="1">{{
            model.ticketsChangeMeter && model.ticketsChangeMeter.changingMeterReasonDetail
          }}</detail-list-item>
          <!-- <detail-list-item term="截止时间">{{model.ticketsDeadline}}</detail-list-item> -->
        </detail-list>
        <a-divider class="aDividerBlue" orientation="left">{{ $t('用户信息') }}</a-divider>
        <detail-list :col="3">
          <detail-list-item :term="$t('用户编号')">{{ model.user && model.user.userId }}</detail-list-item>
          <detail-list-item :term="$t('用户姓名')">{{ userInfo?.userName }}</detail-list-item>
          <detail-list-item :term="$t('手机号码')">{{ userInfo?.userPhone }}</detail-list-item>
          <!-- <detail-list-item term="用户地址">{{model.user&&model.user.userAddr}}</detail-list-item>
          <detail-list-item term="区域名称">{{model.user&&model.user.userAreaName}}</detail-list-item> -->
          <!-- <detail-list-item term="身份证号">{{model.user&&model.user.userIdNumber}}</detail-list-item>
          <detail-list-item term="身份类型">{{model.user&&model.user.userIdType== 1?'自然人': '企业'}}</detail-list-item> -->
          <!-- <detail-list-item term="开户时间">{{userInfo.userCreateTime}}</detail-list-item> -->
          <!-- <detail-list-item term="建档日期">{{userInfo.createTime}}</detail-list-item>
          <detail-list-item term="激活时间">{{userInfo.userActivateTime}}</detail-list-item> -->
          <!-- <detail-list-item term="激活人">{{model.user&&model.user.userActivateBy}}</detail-list-item> -->
          <!-- <detail-list-item term="是否整数计费">{{userInfo.isIntegerBilling==1?'是':'否'}}</detail-list-item> -->
        </detail-list>
        <detail-list :col="3">
          <detail-list-item :term="$t('开户时间')">{{ userInfo.userCreateTime }}</detail-list-item>
          <detail-list-item :term="$t('用水性质')">{{ userInfo.wtName }}</detail-list-item>
          <detail-list-item :term="$t('用水状态')">{{
            userInfo.userState == 0 ? $t('未开始计费') : userInfo.userState == 1 ? $t('已开始计费') : ''
          }}</detail-list-item>
        </detail-list>

        <detail-list :col="3">
          <detail-list-item :term="$t('区域信息')" :itemCol="1">{{ userInfo.userAreaName }}</detail-list-item>
          <detail-list-item :term="$t('用户地址')" :itemCol="1">{{ userInfo.userAddr }}</detail-list-item>
          <!-- <detail-list-item term="用户地址" :itemCol="1">{{meterInfo.userAreaName.slice(meterInfo.userAreaName.indexOf('-')+1,meterInfo.userAreaName.length)+'-'+meterInfo.userAddr}}</detail-list-item> -->
        </detail-list>
        <!-- <detail-list>
          <detail-list-item  :itemCol="1" term="用户地址">{{userInfo.userAreaName?.slice(userInfo.userAreaName.indexOf('-')+1,userInfo.userAreaName?.length)+'-'+userInfo.userAddr}}</detail-list-item>
        </detail-list> -->
        <!-- <detail-list :col="1">
        </detail-list> -->
        <a-divider class="aDividerBlue" orientation="left">{{ $t('旧表具信息') }}</a-divider>
        <detail-list :col="3">
          <detail-list-item :term="$t('旧表编号')">{{
            model.ticketsChangeMeter && model.ticketsChangeMeter.oldMeterId
          }}</detail-list-item>
          <!-- <detail-list-item term="用水性质">{{userInfo.wtName}}</detail-list-item> -->
          <detail-list-item :term="$t('水表厂家')">{{ oldMeter.mtName }}</detail-list-item>
          <detail-list-item :term="$t('口径')">{{ oldMeter.mtCaliber ? 'DN' + oldMeter.mtCaliber : '' }} </detail-list-item>
        </detail-list>

        <template v-if="model.ticketsChangeMeter.isSolve==1">
          <detail-list :col="3">
            <detail-list-item :term="$t('表计费起始读数(m³)')">{{
              model.ticketsChangeMeter && model.ticketsChangeMeter.oldMeterStartNum
            }}</detail-list-item>
            <detail-list-item :term="$t('末次上报结算流量(m³)')">{{
              model.ticketsChangeMeter && model.ticketsChangeMeter.oldUserCalNum
            }}</detail-list-item>
            <detail-list-item :term="$t('末次上报结算余额(元)')">{{
              model.ticketsChangeMeter && model.ticketsChangeMeter.userAccountNum
            }}</detail-list-item>
          </detail-list>

          <detail-list :col="3">
            <detail-list-item :term="$t('末次上报日期')">{{
              model.ticketsChangeMeter && model.ticketsChangeMeter.meterUpTime
            }}</detail-list-item>
          </detail-list>
        </template>
        <template v-else>
          <detail-list :col="3">
            <detail-list-item :term="$t('表计费起始读数(m³)')">{{
              userInfo && userInfo.userMeterStartNum
            }}</detail-list-item>
            <detail-list-item :term="$t('末次上报结算流量(m³)')">{{
              model && model.userCalNum
            }}</detail-list-item>
            <detail-list-item :term="$t('末次上报结算余额(元)')">{{
              userInfo && userInfo.userAccountNum
            }}</detail-list-item>
          </detail-list>

          <detail-list :col="3">
            <detail-list-item :term="$t('末次上报日期')">{{
              model && model.meterUpTime
            }}</detail-list-item>
          </detail-list>
        </template>

        <template v-if="model.ticketsChangeMeter && model.ticketsChangeMeter.newMeterId">
          <a-divider class="aDividerBlue" orientation="left">{{ $t('新表具信息') }}</a-divider>
          <detail-list>
            <detail-list :col="3">
              <detail-list-item :term="$t('新表编号')">{{
                model.ticketsChangeMeter && model.ticketsChangeMeter.newMeterId
              }}</detail-list-item>
              <!-- <detail-list-item term="新表表端累计读数(m³)">{{model.ticketsChangeMeter&&model.ticketsChangeMeter.meterTotalUse}}</detail-list-item>
              <detail-list-item term="新表计费起始读数(m³)">{{model.ticketsChangeMeter&&model.ticketsChangeMeter.meterStartNum}}</detail-list-item>
               -->
              <detail-list-item :term="$t('水表厂家')">{{ newMeter && newMeter.mtName }}</detail-list-item>
              <detail-list-item :term="$t('口径')">
                {{ newMeter && newMeter.mtCaliber ? 'DN' + newMeter.mtCaliber : '' }}
              </detail-list-item>
            </detail-list>
            <!-- <detail-list-item term="换表结算金额(元)">{{model.ticketsChangeMeter&&model.ticketsChangeMeter.meterUserAccountNumAfterChange}}</detail-list-item>
            <detail-list-item term="换表原因">{{['','流量异常','机械故障','其他'][model.ticketsChangeMeter&&model.ticketsChangeMeter.changingMeterReason]}}</detail-list-item> -->
          </detail-list>

          <a-divider class="aDividerBlue" orientation="left">{{ $t('换表操作') }}</a-divider>
          <detail-list>
            <detail-list :col="2">
              <detail-list-item :term="$t('旧表机械读数(m³)')">{{
                model.ticketsChangeMeter && model.ticketsChangeMeter.meterOldMachineSumFlow
              }}</detail-list-item>

              <detail-list-item :term="$t('表开始计费读数(m³)')">{{
                model.ticketsChangeMeter && model.ticketsChangeMeter.meterStartNum == '0.000'
                  ? '0.00'
                  : model.ticketsChangeMeter && model.ticketsChangeMeter.meterStartNum
              }}</detail-list-item>
            </detail-list>

            <detail-list :col="2">
              <detail-list-item :term="$t('旧表图片')" style="display: flex">
                <j-image-upload
                  class="avatar-uploader"
                  :text="$t('上传')"
                  disabled
                  :isMultiple="true"
                  v-model="model.resolvedPictureFront"
                ></j-image-upload>
              </detail-list-item>

              <detail-list-item :term="$t('新表图片')" style="display: flex">
                <j-image-upload
                  class="avatar-uploader"
                  :text="$t('上传')"
                  disabled
                  :isMultiple="true"
                  v-model="model.resolvedPictureOpposite"
                ></j-image-upload>
              </detail-list-item>
            </detail-list>

            <detail-list :col="2">
              <detail-list-item :term="$t('是否以旧表机械读数结算')">
                {{
                  model.ticketsChangeMeter?.whetherSettlementOldTable === null
                    ? ''
                    : model.ticketsChangeMeter?.whetherSettlementOldTable === 1
                    ? $t('是')
                    : $t('否')
                }}
              </detail-list-item>

              <detail-list-item :term="$t('是否收费')">{{ $t(model.payOrNot) }} </detail-list-item>
            </detail-list>

            <detail-list :col="1">
              <detail-list-item :term="$t('电子签名')" style="display: flex">
                <div class="box-sig" @mouseover="isShow = true" @mouseout="isShow = false" v-if="model.ticketsChangeMeter.electronicSignature">
                  <img style="width: 180px; height: 80px" :src="model.ticketsChangeMeter.electronicSignature" />
                  <div class="mask-sig" :class="{ 'mask-show': isShow }">
                    <div class="icon-sig" @click="viewSig"><a-icon type="eye" /></div>
                    <div class="icon-sig" @click="downloadSig"><a-icon type="download" /></div>
                  </div>
                </div>
                <i v-else>{{ $t('暂无签名') }}</i>
              </detail-list-item>
            </detail-list>

            <detail-list :col="2">
              <detail-list-item :term="$t('剩余金额(元)')">
                {{ model.ticketsChangeMeter && model.ticketsChangeMeter.meterUserAccountNumAfterChange }}
              </detail-list-item>
              <detail-list-item :term="$t('收费金额(元)')">
                {{ model.ticketsChangeMeter && model.ticketsChangeMeter.feeAmount }}
              </detail-list-item>
            </detail-list>

            <detail-list :col="2">
              <detail-list-item :term="$t('支付凭证')" style="display: flex" v-if="model.payOrNot == '收费'">
                <j-image-upload
                  class="avatar-uploader"
                  :text="$t('上传')"
                  disabled
                  v-model="model.infoPicture"
                ></j-image-upload>
              </detail-list-item>
              <detail-list-item :term="$t('协议书照片')" style="display: flex" v-if="model.payOrNot == '收费'">
                <j-image-upload
                  class="avatar-uploader"
                  :text="$t('上传')"
                  disabled
                  v-model="model.ticketsChangeMeter.protocolPicture"
                ></j-image-upload>
              </detail-list-item>
            </detail-list>

            <detail-list :col="3">
              <detail-list-item :term="$t('换表原因描述')" :itemCol="1">{{
                model.ticketsChangeMeter && model.ticketsChangeMeter.remark
              }}</detail-list-item>
            </detail-list>
          </detail-list>
          <!-- 照片 -->
        </template>

        <!-- <a-divider class="aDividerBlue" orientation="left">换表信息</a-divider>
        <detail-list>
          <detail-list-item term="旧表机械读数(m³)">{{model.ticketsChangeMeter&&model.ticketsChangeMeter.meterOldMachineSumFlow}}</detail-list-item>
          <detail-list-item term="换表结算金额(元)">{{model.ticketsChangeMeter&&model.ticketsChangeMeter.meterUserAccountNumAfterChange}}</detail-list-item>
        </detail-list> -->
      </j-form-container>
      <j-modal
        :title="$t('预览')"
        :width="448"
        :visible="visibleSig"
        @cancel="handleSigCancel"
        :okButtonProps="{ class: { 'jee-hidden': true } }"
      >
        <div style="width: 400px; height: 400px">
          <img :src="model.ticketsChangeMeter&&model.ticketsChangeMeter.electronicSignature" alt="" style="width: 100%; height: 100%" />
        </div>
      </j-modal>
      <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel1">
        <img alt="example" style="width: 100%" :src="previewImage" />
      </a-modal>
    </a-spin>
  </j-modal>
</template>

<script>
// import {
//   JeecgListMixin
// } from '@/mixins/JeecgListMixin';
import { filterDictTextByCache } from '@/components/dict/JDictSelectUtil'
import { httpAction, getAction } from '@/api/manage'
import { validateDuplicateValue } from '@/utils/util'
import DetailList from '@/components/tools/DetailList'
import JImageUpload from '@/components/jeecg/JImageUpload.vue'
const DetailListItem = DetailList.Item
export default {
  // mixins: [JeecgListMixin],
  name: 'workModal',
  components: {
    DetailList,
    JImageUpload,
    DetailListItem,
  },
  data() {
    return {
      title: '',
      width: 800,
      visible: false,
      disableSubmit: true,
      confirmLoading: false,
      model: {},
      validatorRules: {},
      changingMeterReason: '',
      userInfo: {},
      oldMeter: {},
      newMeter: {},
      url: {
        list: '/jeecg-charge/meter/meterUserinfo/list',
        queryById: '/jeecg-engineering/ticket/tickets/queryById',
        newMeterInfo: '/jeecg-charge/meter/meterinfo/list', //新表接口
        getMeterUserInfoByKeyId: '/jeecg-charge/meter/meteChangeMeterRecord/getMeterUserInfoByKeyId', //换表请求
      },
      isShow: false,
      visibleSig: false,
    }
  },
  computed: {
    options() {
      const t = this.$t
      return [
        {
          value: '0',
          label: t('周期性换表'),
        },
        {
          value: '1',
          label: t('故障换表'),
          children: [
            {
              value: '2',
              label: t('基表问题'),
              children: [
                {
                  value: '3',
                  label: t('计量问题'),
                },
                {
                  value: '4',
                  label: t('阀门故障'),
                },
                {
                  value: '5',
                  label: t('基表爆裂'),
                },
              ],
            },
            {
              value: '6',
              label: t('电子问题'),
              children: [
                {
                  value: '7',
                  label: t('不上传数据'),
                },
                {
                  value: '8',
                  label: t('水表无反应（黑屏，无法激活）'),
                },
              ],
            },
            {
              value: '9',
              label: t('磁干扰'),
            },
            {
              value: '10',
              label: t('缺电'),
            },
            {
              value: '11',
              label: t('其他'),
            },
          ],
        },
      ]
    },
    reasonLabelMap() {
      const map = {}
      const buildMap = (options, parentPath = []) => {
        // 显示 层级路径
        // options.forEach(item => {
        //   const currentPath = [...parentPath, item.label];
        //   map[item.value] = currentPath.join(' / ');
        //   if (item.children) buildMap(item.children, currentPath);
        // });
        // 只显示 最后一级
        options.forEach(item => {
          // 如果是叶子节点（没有 children），存储其 label
          if (!item.children || item.children.length === 0) {
            map[item.value] = item.label
          }
          // 递归处理子级
          if (item.children) {
            buildMap(item.children)
          }
        })
      }
      buildMap(this.options)
      return map
    },
  },
  methods: {
    init(row) {
      let that = this
      this.title = this.$t('详情')
      this.visible = true
      // 获取工单信息
      getAction(this.url.queryById, {
        id: row.id,
      }).then(res => {
        this.model = res.result
        let meterId = ''
        if (this.model.ticketsState == -1) {
          meterId = this.model.ticketsChangeMeter.newMeterId
        } else {
          meterId = this.model.ticketsChangeMeter.oldMeterId
        }
        if (that.model.ticketsChangeMeter.changingMeterReason != null) {
          // 将后端返回的最后一层值转换为完整路径
          const fullPath = that.findCascaderPath(that.model.ticketsChangeMeter.changingMeterReason)
          that.changingMeterReason = fullPath
        }
        if (that.model.ticketsChangeMeter && that.model.ticketsChangeMeter.whetherSettlementOldTable == null) {
          this.$set(that.model, 'whetherSettlementOldTable', undefined)
        }

        // 是否收费
        if (that.model.infoPicture) {
          this.$set(that.model, 'payOrNot', '收费')
        } else {
          this.$set(that.model, 'payOrNot', '不收费')
        }

        // 获取用户信息
        getAction(this.url.list, { userId: this.model.user.userId }).then(res => {
          if (res.success) {
            this.userInfo = res.result.records[0] || {}
          }
        })

        // 获取旧表信息
        getAction(this.url.newMeterInfo, { meterId: meterId }).then(res => {
          if (res.success) {
            this.oldMeter = res.result.records[0] || {}
          }
        })

        getAction(that.url.getMeterUserInfoByKeyId, { userKeyId: that.model.ticketsChangeMeter.userKeyId }).then(
          res => {
            if (res.success) {
              this.$set(that.model, 'meterUpTime', res.result.meterUpTime)
              this.$set(that.model, 'userCalNum', res.result.userCalNum)
            }
          }
        )

        // 获取新表信息
        if (this.model.ticketsChangeMeter.newMeterId) {
          let params = {
            meterId: this.model.ticketsChangeMeter.newMeterId,
          }
          getAction(this.url.newMeterInfo, params).then(res => {
            if (res.success) {
              this.newMeter = res.result.records[0] || {}
            }
          })
        }
        console.log('当前回显数据this.model=', this.model)
      })
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    handleCancel() {
      this.close()
    },
    setJJ(item) {
      return filterDictTextByCache('ticketsEmergency', item)
    },
    // 根据最后一层值查找完整路径，并返回全路径的label（使用/拼接）
    findCascaderPath(leafValue) {
      const stack = [...this.options.map(item => ({ path: [item.label], node: item }))]

      while (stack.length) {
        const { path, node } = stack.pop()

        // 找到目标节点，返回路径
        if (String(node.value) === String(leafValue)) {
          return path.join(' / ') // 返回用"/"拼接的完整路径label
        }

        // 如果有子节点，继续查找
        if (node.children) {
          stack.push(
            ...node.children.map(child => ({
              path: [...path, child.label], // 使用label构建路径
              node: child,
            }))
          )
        }
      }

      return '' // 没找到返回空字符串
    },
    getTagColor(value) {
      switch (value) {
        case 0:
          return 'red'
        case 1:
          return 'orange'
        case 2:
          return 'yellow'
        case 3:
          return 'blue'
        default:
          return 'default' // 你可以设置一个默认颜色
      }
    },
    viewSig() {
      this.visibleSig = true
    },
    handleSigCancel() {
      this.visibleSig = false
    },
    downloadSig() {
      this.downloadFile(this.model.ticketsChangeMeter.electronicSignature, this.$t('签名'))
    },
    downloadFile(url, name) {
      console.log('url==', url)
      var a = document.createElement('a')
      a.setAttribute('href', url)
      a.setAttribute('download', name)
      a.setAttribute('target', '_blank')
      let clickEvent = document.createEvent('MouseEvents')
      clickEvent.initEvent('click', true, true)
      a.dispatchEvent(clickEvent)
    },
  },
}
</script>
<style scoped lang="less">
::v-deep(.detail-list .content) {
  line-height: normal;
}
.box-sig {
  width: 200px;
  height: 100px;
  position: relative;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  .mask-sig {
    visibility: hidden;
    position: absolute;
    width: 180px;
    height: 80px;
    top: 10px;
    left: 10px;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    cursor: pointer;

    .icon-sig {
      color: rgba(255, 255, 255, 0.85);
      font-size: 16px;
    }
  }
  .mask-show {
    visibility: visible;
    transition: all 0.3s;
  }
}
</style>
